import { makeStyles } from '@material-ui/core/styles'
import { BREAKPOINTS, COLORS, FONTS } from '../../constants'

export const styles = makeStyles(theme => ({
  formControl: {
    width: '100%',
    minWidth: 110,
    maxWidth: 300,
    position: 'relative',
    borderBottom: `1px solid ${COLORS.darkGrey} !important`,
    '&:hover': {
      borderBottom: `2px solid ${theme.palette.common.black} !important`,
    },
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  selectList: {
    padding: 10,
    paddingLeft: 90,
    [`@media (max-width: ${BREAKPOINTS.mdd}px)`]: {
      padding: 7,
      paddingLeft: 50,
    },
    ['& > select']: {
      padding: 0,
      paddingLeft: 10,
      paddingRight: 0,
      backgroundColor: 'unset!important',
      fontFamily: FONTS.Schnyder.SchnyderMLight,
      fontSize: '1.875rem',
      lineHeight: 'normal',
      [`@media (max-width: ${BREAKPOINTS.mdd}px)`]: {
        fontSize: '20px',
      },
      ['& > option']: {
        [`@media (max-width: ${BREAKPOINTS.mdd}px)`]: {
          fontSize: '20px',
        },
        fontFamily: FONTS.Schnyder.SchnyderMLight,
      },
    },
  },
  sortByText: {
    fontFamily: FONTS.Schnyder.SchnyderMLight,
    fontSize: '1.875rem',
    fontWeight: 400,
    position: 'absolute',
    bottom: 7.5,
    left: 0,
    margin: 0,
    [`@media (max-width: ${BREAKPOINTS.md}px)`]: {
      // fontSize: '1.25rem',
    },
    [`@media (max-width: ${BREAKPOINTS.mdd}px)`]: {
      fontSize: '20px',
    },
  },
}))
